<template>
  <div class="versions-admin">
    <div class="action-bar">
      <el-button type="primary" @click="showAddDialog">添加版本</el-button>
    </div>

    <!-- 版本列表 -->
    <el-table
      :data="versionsList"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="version"
        label="版本号"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        min-width="200"
      ></el-table-column>
      <el-table-column
        prop="file_url"
        label="文件"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.file_url"
            size="mini"
            type="text"
            @click="openFile(scope.row.file_url)"
          >
            查看文件
          </el-button>
          <span v-else>无文件</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.row)"
          >编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%">
      <el-form :model="versionForm" ref="versionForm" label-width="100px" :rules="rules">
        <el-form-item label="版本号" prop="version">
          <el-input v-model="versionForm.version" placeholder="请输入版本号，如1.0.0"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="versionForm.title" placeholder="请输入版本标题"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="versionForm.description" type="textarea" :rows="5" placeholder="请输入版本描述，支持HTML格式"></el-input>
        </el-form-item>

        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持各种格式文件，如zip、exe、dmg等</div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="versionForm.file_url">
          <el-link :href="versionForm.file_url" target="_blank" type="primary">{{ getFileName(versionForm.file_url) }}</el-link>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'WebsiteVersionsAdmin',
  data() {
    return {
      versionsList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      dialogVisible: false,
      dialogTitle: '添加版本',
      isEdit: false,
      fileList: [],
      versionForm: {
        id: null,
        version: '',
        title: '',
        description: '',
        file_url: ''
      },
      rules: {
        version: [
          { required: true, message: '请输入版本号', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入版本标题', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    uploadUrl() {
      return '/api/admin/upload';
    },
    uploadHeaders() {
      return {
        Authorization: `Bearer ${localStorage.getItem('adminToken')}`
      };
    }
  },
  created() {
    this.fetchVersionsList();
  },
  methods: {
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    },
    
    // 获取文件名
    getFileName(url) {
      if (!url) return '';
      const parts = url.split('/');
      return parts[parts.length - 1];
    },
    
    // 打开文件
    openFile(url) {
      window.open(url, '_blank');
    },
    
    // 获取版本列表
    async fetchVersionsList() {
      this.loading = true;
      try {
        const response = await request.get('/api/admin/versions', {
          params: {
            page: this.currentPage,
            limit: this.pageSize
          }
        });
        this.versionsList = response.data.data;
        this.total = response.data.total;
      } catch (error) {
        console.error('获取版本列表失败:', error);
        this.$message.error('获取版本列表失败');
      } finally {
        this.loading = false;
      }
    },
    
    // 分页处理
    handleCurrentChange(page) {
      this.currentPage = page;
      this.fetchVersionsList();
    },
    
    // 每页显示条数变化
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchVersionsList();
    },
    
    // 显示添加对话框
    showAddDialog() {
      this.isEdit = false;
      this.dialogTitle = '添加版本';
      this.versionForm = {
        id: null,
        version: '',
        title: '',
        description: '',
        file_url: ''
      };
      this.fileList = [];
      this.dialogVisible = true;
    },
    
    // 编辑版本
    async handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑版本';
      
      try {
        const response = await request.get(`/api/admin/versions/${row.id}`);
        this.versionForm = { ...response.data };
        
        // 设置文件列表
        this.fileList = [];
        if (this.versionForm.file_url) {
          this.fileList = [{
            name: this.getFileName(this.versionForm.file_url),
            url: this.versionForm.file_url
          }];
        }
        
        this.dialogVisible = true;
      } catch (error) {
        console.error('获取版本详情失败:', error);
        this.$message.error('获取版本详情失败');
      }
    },
    
    // 删除版本
    handleDelete(row) {
      this.$confirm('确定要删除这个版本吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await request.delete(`/api/admin/versions/${row.id}`);
          this.$message.success('删除成功');
          this.fetchVersionsList();
        } catch (error) {
          console.error('删除版本失败:', error);
          this.$message.error('删除版本失败');
        }
      }).catch(() => {
        // 取消删除
      });
    },
    
    // 上传前验证
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过100MB!');
      }
      return isLt100M;
    },
    
    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      this.$message.success('文件上传成功');
      this.versionForm.file_url = response.url;
      this.fileList = fileList;
    },
    
    // 上传失败回调
    handleUploadError(err) {
      console.error('文件上传失败:', err);
      this.$message.error('文件上传失败');
    },
    
    // 提交表单
    submitForm() {
      this.$refs.versionForm.validate(async (valid) => {
        if (valid) {
          try {
            if (this.isEdit) {
              // 更新版本
              await request.put(`/api/admin/versions/${this.versionForm.id}`, this.versionForm);
              this.$message.success('版本更新成功');
            } else {
              // 创建版本
              await request.post('/api/admin/versions', this.versionForm);
              this.$message.success('版本创建成功');
            }
            
            this.dialogVisible = false;
            this.fetchVersionsList();
          } catch (error) {
            console.error('保存版本失败:', error);
            this.$message.error('保存版本失败');
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.versions-admin {
  padding: 20px;
}

.action-bar {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
</style>